import type { ComboboxItem } from '@node-space/ui-components'
import { TIMEZONE_OPTIONS } from 'constants/timezones'

export const mapTimezonesToComboboxItems = (): ComboboxItem[] => {
  return TIMEZONE_OPTIONS.map(({ offset, zone }) => ({
    value: offset,
    leftText: `${offset} (${zone})`,
  }))
}
